export default function consolidations(state = [], action) {
  switch (action.type) {
    default:
      return state;
  }
}
